module.exports = __webpack_public_path__ + "static/media/bin.67efdd1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/bg/bin.png
// module id = 2952
// module chunks = 0